import { ReactNode } from 'react';
import { forwardRef, useDisclosure, useMultiStyleConfig } from '@chakra-ui/react';
import Box, { BoxProps } from '../Box/Box';
import Collapse from '../Collapse/Collapse';
import Card, { CardProps } from '../Card/Card';
import Icon from '../Icon/Icon';

export interface ExpandableCardProps
  extends Omit<
    CardProps,
    | 'p'
    | 'pt'
    | 'paddingTop'
    | 'pr'
    | 'paddingRight'
    | 'pe'
    | 'paddingEnd'
    | 'pb'
    | 'paddingBottom'
    | 'pl'
    | 'paddingLeft'
    | 'ps'
    | 'paddingStart'
    | 'px'
    | 'paddingX'
    | 'py'
    | 'paddingY'
    | 'paddingInlineStart'
    | 'paddingInlineEnd'
    | 'onChange'
  > {
  buttonContent: ReactNode;
  buttonPadding?: BoxProps['padding'];
  isExpanded?: boolean;
  onChange?: (isOpened: boolean) => void;
}
const ExpandableCard = forwardRef<ExpandableCardProps, 'div'>((props, ref) => {
  const { buttonContent, children, isExpanded, padding = '16', buttonPadding = '16', onChange, ...rest } = props;

  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: isExpanded });

  const onButtonClick = () => {
    onToggle();
    if (onChange) {
      onChange(!isOpen);
    }
  };

  const style = useMultiStyleConfig('ExpandableCard', { isOpen });

  return (
    <Card sx={style.box} variant="outline" {...rest} ref={ref}>
      <Box __css={style.button} as="button" onClick={onButtonClick} padding={buttonPadding} data-group type="button">
        {buttonContent}
        <Icon __css={style.chevron} name="ChevronDown" />
      </Box>
      <Collapse in={isOpen} style={{ overflow: 'unset' }}>
        <Box padding={padding}>{children}</Box>
      </Collapse>
    </Card>
  );
});

export default ExpandableCard;
